// src/components/CarWash/CarWashHome.tsx
import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useCustomerForm } from "../home/hooks/useCustomerForm";
import CustomerForm from "../home/components/CustomerForm";
import "./CarWashHome.css";
import { PageTitle } from "src/shared/PageTitle";
import { useUser } from "src/shared/context/UserContext";
import SubscriptionDialog from "src/shared/modules/admin/auth/components/SubscriptionDialog";
import { pageTitle } from "src/shared/utils/brand";

const CarWashHome: React.FC = () => {
  // const { isLoading } = useCarWashServices();
  const { name, setName, phoneNumber, setPhoneNumber, date, setDate, handleSubmit } = useCustomerForm();
  const { subscriptionInfo } = useUser();
  const [showDialog, setShowDialog] = useState(false);
  const [message, setMessage] = useState<React.ReactNode>("");
  useEffect(() => {
    document.title = pageTitle("Customer Details");
  }, []);

  useEffect(() => {
    if (!subscriptionInfo) return;

    const alreadyShown = sessionStorage.getItem("subscription_dialog_shown");
    if (alreadyShown === "true") return;

    if (subscriptionInfo.status === "grace_period") {
      const days = subscriptionInfo.daysRemaining;

      const formattedMessage = (
        <>
          This is a reminder that your current subscription will expire in <strong>{days} day(s)</strong>. Please renew now to avoid service disruption.
        </>
      );

      setMessage(formattedMessage);
      setShowDialog(true);
      sessionStorage.setItem("subscription_dialog_shown", "true");
      return;
    }

    // WARNING CASE
    if (subscriptionInfo.warning) {
      setMessage(subscriptionInfo.warning);
      setShowDialog(true);
      sessionStorage.setItem("subscription_dialog_shown", "true");
      return;
    }
  }, [subscriptionInfo]);

  // if (isLoading) return <div>Loading services...</div>;

  return (
    <div>
      <PageTitle title="Point of Sale - Home" />
      <CustomerForm name={name} setName={setName} phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber} date={date} setDate={setDate} onSubmit={handleSubmit} />
      <SubscriptionDialog
        open={showDialog}
        message={message}
        onClose={() => setShowDialog(false)}
        onRenew={() => {
          setShowDialog(false);
          // navigate to subscription page
        }}
      />
      <ToastContainer />
    </div>
  );
};

export default CarWashHome;
